import { useMutation, useQueryClient } from '@tanstack/react-query';

import { DocumentsService } from '@/openapi';
import { queryKeys } from '@/util/queryKeys';

export const useDeleteDocumentMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (path: string) => {
      return DocumentsService.documentsServiceDeleteDocument({
        body: { path },
      });
    },
    onSettled: async () => {
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: queryKeys.documents.list() }),
        queryClient.invalidateQueries({
          queryKey: queryKeys.documents.metadata(),
        }),
      ]);
    },
  });
};
